export default "__VITE_ASSET__BtUs0tPZ__";